import {
  useWindowSize as _useWindowSize,
  type UseWindowSizeOptions
} from '@vueuse/core'

export function useWindowSize(options?: UseWindowSizeOptions) {
  return _useWindowSize(options)
}
